import { TenantUserAccessRolesUtils } from '../model/tenant-user-access-roles-utils'

export type { AgencyStructureWithAccessRoles } from '../model/tenant-user-access-roles-utils'

/**
 * Exposes the pure {@link TenantUserAccessRolesUtils} helpers to the component
 * layer (the MVVM-blessed indirection over same-package `model/`).
 */
export function useTenantUserAccessRolesUtils() {
  return { TenantUserAccessRolesUtils }
}
